export default function (selector, set, animate, delay = 0) {
  if (this.section.querySelector(selector)) {
    this.tlSet.add(set);
    this.tlAnimate.add(animate, delay);
  }
}



// WEBPACK FOOTER //
// ./scripts/animation/add-element-to-timeline.js